import React from 'react'
import PropTypes from 'prop-types'
import './style.sass'

const CustomCard = ({ children }) => {
  return (
    <div className="custom-card-component-container">
      {children}
    </div>
  )
}

CustomCard.propTypes = {
  children: PropTypes.node
}

export default CustomCard
